"use client"

import { Typography } from "@mui/material"
import Link from "next/link"
import React from "react"
import { getNonUmbracoUrl } from "utils"
import { colors } from "../../theme/colors"
import { StyledMegaMenuItem } from "./styles"

type MegaMenuItemProps = {
  item: any
  outerIndex: number
  outerChildren: any
  handleItemClick?: (href: string, buttonText?: string) => void
}

const MegaMenuItem: React.FC<MegaMenuItemProps> = ({
  item,
  outerIndex,
  handleItemClick,
}) => {
  return (
    <StyledMegaMenuItem key={`mega-item-${item?.name}-${outerIndex}`}>
      <Link
        id={`${item?.name}-${outerIndex}`}
        className="title"
        href={getNonUmbracoUrl(item.url ? item.url : "")}
        onClick={() => {
          if (handleItemClick && item?.url) {
            handleItemClick(getNonUmbracoUrl(item.url), item?.name)
          }
        }}
      >
        <Typography
          variant="body1"
          color={colors.black}
          fontWeight={400}
          style={{ fontSize: "18px", height: "100%" }}
          width={"100%"}
        >
          {item?.name}
        </Typography>
      </Link>
    </StyledMegaMenuItem>
  )
}

export default React.memo(MegaMenuItem)
